import { useFormik } from "formik";
import React from "react";
import {
  Button,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import FranchiseEnquiryService from "../../../services/KangarooServices/FranchiseEnquiryService";
import { values } from "lodash";
import toast from "react-hot-toast";

const UpdateStatus = ({ isOpen, toggle, selectedItem }) => {
  console.log("🚀 ~ UpdateStatus ~ selectedItem:", selectedItem);
  const formik = useFormik({
    initialValues: {
      status: selectedItem?.status || 1,
      adminNotes: selectedItem?.adminNotes || "",
    },
    enableReinitialize: true,
    onSubmit: async (values) => {
      try {
        const payload = {
          ...values,
          status: Number(values.status), // 👈 convert to int
        };

        const response = await FranchiseEnquiryService.UpdateStatus(
          selectedItem?.id,
          payload
        );
        toggle()
        toast.success(response);
      } catch (error) {
        console.log(error);
        toast.error(error);
      }
    },
  });
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Update Status</ModalHeader>
      <ModalBody>
        <form onSubmit={formik.handleSubmit}>
          <div className="mb-3">
            <Label>Status</Label>
            <select
              name="status"
              className="form-select"
              value={formik.values.status}
              onChange={(e) =>
                formik.setFieldValue("status", Number(e.target.value))
              }
            >
              <option value={1}>New</option>
              <option value={2}>InProgress</option>
              <option value={3}>Closed</option>
            </select>
          </div>
          <FormGroup className="mb-3">
            <Label htmlFor="adminNotes">Notes</Label>
            <Input
              id="adminNotes"
              name="adminNotes"
              type="textarea"
              rows={3}
              value={formik.values.adminNotes}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              invalid={formik.touched.adminNotes && !!formik.errors.adminNotes}
            />
            {formik.touched.adminNotes && formik.errors.adminNotes && (
              <FormFeedback>{formik.errors.adminNotes}</FormFeedback>
            )}
          </FormGroup>
          <Row>
            <div className="hstack gap-2 justify-content-end mt-4 mb-3">
              <Button color="success" type="submit">
                Update
              </Button>
              <Button color="danger" type="button" onClick={toggle}>
                Cancel
              </Button>
            </div>
          </Row>
        </form>
      </ModalBody>
    </Modal>
  );
};

export default UpdateStatus;
